import { BaseEdge, EdgeLabelRenderer, EdgeProps, getSmoothStepPath, useReactFlow } from 'reactflow'
import { tokens } from 'styling/tokens'
import { EdgeDeleteButton } from '../Workflows.styled'

export const DeletableEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  markerEnd,
  selected,
  data,
}: EdgeProps) => {
  const { setEdges } = useReactFlow()
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  })

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation()
    setEdges((edges) => edges.filter((edge) => edge.id !== id))
  }

  const isOptional = (data as { linkType?: 1 | 2 })?.linkType === 2

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: tokens.accent.base,
          strokeWidth: 2,
          strokeDasharray: isOptional ? '6 4' : undefined,
          ...style,
        }}
      />
      <EdgeLabelRenderer>
        <EdgeDeleteButton
          show={Boolean(selected)}
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
          }}
          onClick={handleRemove}
          title='Remove link'
        >
          ×
        </EdgeDeleteButton>
      </EdgeLabelRenderer>
    </>
  )
}
